import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FcpCardComponent } from './fcp-card.component';
import { FcpArticleCardComponent } from './fcp-article-card';
import { FcpFolderCardComponent } from './fcp-folder-card';
import { FcpIconModule } from '../fcp-icon';
import { FcpTileCardComponent } from './fcp-tile-card';
import { FcpButtonModule } from '../fcp-button';
import { FcpStoreCardComponent } from './fcp-store-card';

@NgModule({
    declarations: [
        FcpCardComponent,
        FcpArticleCardComponent,
        FcpFolderCardComponent,
        FcpTileCardComponent,
        FcpStoreCardComponent
    ],
    exports: [FcpCardComponent],
    imports: [CommonModule, FcpIconModule, FcpButtonModule]
})
export class FcpCardModule {}
